import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentSeparateSignPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: DocumentSeparateSignPayload) =>
    $actions.document.getSeparateDocumentDownloadUrl(dispatch, payload),
  );
};
